import { clsx } from 'clsx'
import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { ATTRIBUTE_NAME_PACKAGE_SIZE } from '../../product-page-context/ATTRIBUTE_NAME'
import {
  type AttributeSelectionRenderGroups,
  type SelectionEntry,
} from '../../product-page-context/useProductPageAttributeSelectionControls'
import { useProductPageRebrushStyle } from '../../product-page-context/useProductPageRebrushStyle'
import { useProductPageContext } from '../../productPageContext'

import { ProductPageVariant } from './ProductPageVariant'

type ProductPageMobileRadioStyleAttributesSelectionProps = {
  className?: string
}

/**
 * important we render only packaging size.
 * in some edgecases there may be as well other attributes but they are ignored only on mobile (e.g. "packaging_variant: Set")
 */
const getSelectionEntriesToRender = (
  renderGroups: AttributeSelectionRenderGroups,
): SelectionEntry[] => {
  return (
    renderGroups.find(
      (it) =>
        it.group?.metaAttributeData.variant_attribute ===
        ATTRIBUTE_NAME_PACKAGE_SIZE,
    )?.group?.selectionEntries ?? []
  )
}

/**
 * on mobile, in some cases, we only show the packaging size in an "old school" radio button style
 */
export const ProductPageMobileRadioStyleAttributesSelection: FC<
  ProductPageMobileRadioStyleAttributesSelectionProps
> = ({ className }) => {
  const { attributeSelectionControls } = useProductPageContext()
  const isRebrushStyle = useProductPageRebrushStyle()

  const selectionEntries = getSelectionEntriesToRender(
    attributeSelectionControls.renderGroups,
  )

  if (selectionEntries.length <= 1) {
    return null
  }

  return (
    <div className={className}>
      <p className="font-medium text-dark-primary-low">
        <FormattedMessage id="buybox.headLine.packageSize" />
      </p>
      <ul
        className={clsx(
          '-mb-2.5 mt-2.5 flex flex-col',
          isRebrushStyle && 'gap-3.5 pb-5',
        )}
      >
        {selectionEntries
          .filter((entry) => entry.allCandidateVariants.length > 0)
          .map((entry) => (
            <ProductPageVariant
              key={entry.allCandidateVariants[0].upid}
              selectionEntry={entry}
            />
          ))}
      </ul>
    </div>
  )
}
